import React, { useState, useEffect, useContext } from "react";
import { Alert, Col, Row, Container, Button, Table } from "react-bootstrap";

import { Editor, EditorState } from "draft-js";
import 'draft-js/dist/Draft.css';
import { stateFromHTML } from 'draft-js-import-html';
import { sanitizeHistoryHtml } from '../../../Utils/historyHtml';

import { BsArrowLeft, BsFillPlusCircleFill } from "react-icons/bs";
import { BiSave } from "react-icons/bi";

import Logo4BPM from "../../../components/Logo4BPM";
import LogoPMMA from "../../../components/Logo_PMMA";

import MaterialDetalhe from "./MaterialDetalhe";
import PolicialDetalhe from "./PolicialDetalhe";
import EnvolvidosDetalhe from "./EnvolvidosDetalhe";
import ImprimirBoletimButton from "../../../components/ImprimirBoletimButton";

import { Link, useNavigate } from "react-router-dom";
import { BoletimContext } from "../../../context/BoletimContext";
import { boletimValidationError } from '../../../Utils/boletimValidation';
import './boletim-detalhe.css';
import { formatOperationalDateTime as formatarDataHora } from '../../../Utils/operationalDateTime';

const BoletimDetalhe = () => {
  const { boletim, setBoletim, saveNow, syncStatus = { state: "disabled" }, discardCurrentDraft } = useContext(BoletimContext);
  const navigate = useNavigate();
  const [saveMessage, setSaveMessage] = useState("");
  const [saveMessageIsError, setSaveMessageIsError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // State do editor
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  // Inicializa editor quando o boletim muda
  useEffect(() => {
    const state = boletim.historicohtml
      ? EditorState.createWithContent(stateFromHTML(sanitizeHistoryHtml(boletim.historicohtml)))
      : EditorState.createEmpty();
    setEditorState(state);
  }, [boletim.historicohtml]);

  // Formata data e hora


  // Cria um novo boletim
  const novoBoletim = async () => {
    const hasPendingData = syncStatus.state !== "synced" &&
      Boolean(boletim.numero || boletim.data || boletim.natureza || boletim.historicohtml ||
        boletim.envolvidos?.length || boletim.materiaisApreendidos?.length || boletim.efetivo?.length);
    if (hasPendingData && !window.confirm("Este boletim possui alterações ainda não confirmadas pelo servidor. Descartar essas alterações e iniciar outro?")) return;
    if (hasPendingData) await discardCurrentDraft();
    const newBoletim = {
      numero: "",
      natureza: "",
      naturezaId: "",
      naturezaIds: [],
      data: "",
      horario: "",
      endereco: "",
      bairro: "",
      municipio: "",
      referencia: "",
      latitude: "",
      longitude: "",
      envolvidos: [],
      materiaisApreendidos: [],
      efetivo: [],
      historicohtml: "",
      // NÃO colocar id ou _id, MongoDB vai gerar
    };
    setBoletim(newBoletim);
    navigate('/dashboard');
  };

  const saveIncidentReportOnDataBase = async ({ finalizationIntent = false } = {}) => {
    setSaveMessage("");
    const validationError = syncStatus.state === 'synced' && boletim._id ? null : boletimValidationError(boletim);
    if (validationError) {
      setSaveMessage(validationError.message);
      setSaveMessageIsError(true);
      window.setTimeout(() => document.getElementById('boletim-save-message')?.focus(), 0);
      return null;
    }

    try {
      setIsSaving(true);
      const result = await saveNow({ finalizationIntent });
      if (result.error) throw result.error;
      if (result.offline) {
        setSaveMessage("Rascunho salvo neste dispositivo. Ainda não foi registrado oficialmente no servidor.");
        setSaveMessageIsError(false);
        return result.report;
      }
      setSaveMessage("Boletim salvo no servidor.");
      setSaveMessageIsError(false);
      return result.report;
    } catch (err) {
      console.error(err);
      setSaveMessage(err.response?.data?.message || err.message || "Erro ao salvar o boletim.");
      setSaveMessageIsError(true);
      return null;
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Container className="bo-review" style={{ fontSize: "12px" }}>
      <br />
      {syncStatus.state !== "synced" && syncStatus.state !== "disabled" && (
        <Alert variant="warning" className="bo-provisional-banner" role="status">
          <strong>CÓPIA PROVISÓRIA — NÃO CONFIRMADA PELO SERVIDOR</strong>
          <div>Identificação oficial e QR Code não serão emitidos nesta impressão. Sincronize o rascunho quando a conexão retornar.</div>
        </Alert>
      )}
      <Row className="text-center">
        <Col><LogoPMMA /></Col>
        <Col style={{ fontSize: "10px" }}>
          <b>
            <p>ESTADO DO MARANHÃO <br />
              SECRETARIA DE ESTADO DA SEGURANÇA PÚBLICA<br />
              POLÍCIA MILITAR DO MARANHÃO<br />
              COMANDO DO POLICIAMENTO DE ÁREA DO INTERIOR – CPAI-6<br />
              4º BATALHÃO DE POLÍCIA MILITAR
            </p>
          </b>
        </Col>
        <Col><Logo4BPM /></Col>
      </Row>

      <Row>
        <Col className="text-center">
          OCORRÊNCIA NUMERO:<b> {boletim.numero} {boletim.dataRegistro}</b>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">Registrado em :<b> {formatarDataHora(boletim.createdAt)}</b></Col>
      </Row>
      <hr />

      {/* Dados do boletim */}
       <Row className="text-center d-print-none"><h6>Fato(S)<Link className="d-print-none" to="/boletim/header">Editar</Link></h6></Row>
      <Row>
        <Col><b>Natureza da Ocorrência: </b> {boletim.natureza}</Col>
        <Col><b>Data do Fato: </b> {boletim.data}</Col>
        <Col><b>Horário do Fato: </b> {boletim.horario}</Col>
      </Row>
      <Row>
        <Col><b>Local:</b> {boletim.endereco} {boletim.numeroEndereco}</Col>
        <Col><b>Bairro:</b> {boletim.bairro}</Col>
        <Col><b>Municipio:</b> {boletim.municipio}</Col>
      </Row>
      <Row>
        <Col><b>Ponto de Refêrencia :</b> {boletim.referencia}</Col>
        <Col><b>Coordenadas:</b> {boletim.latitude} {boletim.longitude}</Col>
        <Col></Col>
      </Row>
      <hr />

      {/* Envolvidos */}
      <Row className="text-center"><h6>ENVOLVIDO(S)<Link className="d-print-none" to="/boletim/envolvido">Editar</Link></h6></Row>
      {boletim.envolvidos.map((envolvido, index) => (
        <EnvolvidosDetalhe key={envolvido._id || envolvido.id || index} envolvido={envolvido} />
      ))}

      <hr />

      {/* Materiais */}
      <Row className="text-center"><h6>ARMAS E OBJETOS APREENDIDOS<Link className="d-print-none" to="/boletim/material">Editar</Link></h6></Row>
      {boletim.materiaisApreendidos.map((material, index) => (
        <MaterialDetalhe key={material._id || material.id || index} material={material} />
      ))}

      <hr />

      {/* Histórico */}
      <Row className="text-center"><h6>HISTÓRICO <Link className="d-print-none" to="/boletim/historico">Editar</Link></h6></Row>
      <Row className="text-justify">
        <Editor editorState={editorState} onChange={setEditorState} readOnly={true} />
      </Row>
      <hr />

      {/* Efetivo */}
      <Row className="text-center"><h6>EFETIVO EMPREGADO <Link className="d-print-none" to="/boletim/efetivo">Editar</Link></h6></Row>
      <Row>
        {boletim.efetivo.map(policial => <PolicialDetalhe key={policial._id || policial.id} policial={policial} />)}
      </Row>
        {/* Unidade de Entrega */}
            <hr />
            <Row className="text-center"><h6>UNIDADE DE ENTREGA</h6></Row>
            <Table borderless responsive>
            <tbody>
                <tr>
                <td>Unidade ___________________________</td>
                <td>Data  _______/________/_______</td>
                <td>Hora       _________:_________</td>
                </tr>
                <tr>
                <td>Matricula ___________________________</td>
                <td>Nome ______________________________</td>
                <td>Assinatura ___________________________</td>
                </tr>
            </tbody>
            </Table>
      <hr />
      {saveMessage && (
        <Alert
          id="boletim-save-message"
          tabIndex={-1}
          variant={saveMessageIsError ? "danger" : "success"}
          role={saveMessageIsError ? "alert" : "status"}
          className="d-print-none"
          style={{ whiteSpace: 'pre-line' }}
        >
          {saveMessage}
          {saveMessageIsError && <div><Link to="/boletim/header">Revisar dados gerais e coordenadas</Link></div>}
        </Alert>
      )}
      <Row className="text-center mt-2">
        <Col>
          <Button
            as={Link}
            to="/dashboard"
            className="d-print-none"
            size="sm"
            variant="outline-secondary"
          >
            Voltar ao dashboard
          </Button>
        </Col>
        <Col>
          <Button className="d-print-none" size="sm" variant="outline-primary">
            <Link className="text-decoration-none" to="../historico">
              <BsArrowLeft /> Voltar
            </Link>
          </Button>
        </Col>
        <Col className="text-center">
          <ImprimirBoletimButton
            report={boletim}
            prepareReport={() => saveIncidentReportOnDataBase({ finalizationIntent: true })}
            className="d-print-none"
          />
        </Col>
        <Col>
          <Button
            onClick={() => saveIncidentReportOnDataBase()}
            className="d-print-none"
            size="sm"
            variant="success"
            disabled={isSaving}
          >
            {isSaving ? "Salvando..." : <>Salvar <BiSave /></>}
          </Button>
        </Col>
        <Col>
          <Button onClick={novoBoletim} className="d-print-none" size="sm" variant="danger">
            Novo B.O <BsFillPlusCircleFill />
          </Button>
        </Col>
      </Row>
      <br />
    </Container>
  );
};

export default BoletimDetalhe;
